<template lang="pug">
  el-tooltip(effect='dark', placement='top')
    div(slot='content') {{ tooltipContent }}
    el-popover(placement='top' width='360' v-model='showRelease')
      p {{ popoverContent }}
      div(style='text-align: right; margin: 0')
        el-input(placeholder="Σχόλιο Αποδέσμευσης", v-model="releaseComment", type="textarea")
        p
          el-button(size='mini', type='text', @click='showRelease = false')
            | Άκυρο
          el-button(type='primary', size='mini', @click='releaseApplication', :disabled='enableRelease')
            | Αποστολή
      el-button(slot='reference', size='mini', type='warning',
        @click='showRelease = true',
        :disabled="!releaseChecked") Αποδέσμευση σε {{ relOrRer }}
</template>

<script>
import sharedMethods from '../common/sharedMethods.js'

export default {
  mixins: [sharedMethods],
  props: {
    releaseOrReroute: String,
    popoverContent: String,
    tooltipContent: String,
    releaseByUser: String,
    releaseChecked: {
      type: Boolean,
      default: false
    },
    workingApplicationId: Number
  },
  data () {
    return {
      releaseComment: '',
      showRelease: false
    }
  },
  methods: {
    releaseApplication () {
      this.$confirm(`Η αίτηση θα δρομολογηθεί πίσω στον τελευταίο ${this.relOrRer}.`,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        this.$store.dispatch('RELEASE_WORKING_APPLICATION',
          {
            id: this.workingApplicationId,
            role: this.releaseByUser,
            comment: this.releaseComment,
            releaseOrReroute: this.releaseOrReroute
          })
          .then(() => {
            this.$emit('releasedDoc', true)
          })
          .catch(() => {
            this.$emit('releasedDoc', false)
          })
      }).catch(() => {
        this.frontEndError('Η αίτηση δεν αποδεσμεύτηκε!')
      })
    }
  },
  computed: {
    relOrRer () {
      // return this.releaseOrReroute === 'release' ? 'προέλεγχο' : 'εισηγητή'
      return this.releaseOrReroute === 'release' ? 'Προέλεγχο' : 'Χειριστή'
    },
    enableRelease () {
      return this.releaseComment.length < 5
    },
    cannotReroute () {
      const history = this.searchedApplication.applicationHistory

      return history &&
        history.length > 5 &&
        history.find(step => step.applicationStatus === 'proponentW_President') &&
        this.last(history).applicationStatus === 'proponentW_Admin'
    },
    enableReroute () {
      return this.rerouteComment.length < 5
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/releaseButton.vue